<template>
<div name="student">

    <MobileHeader></MobileHeader>
    <div class="d-flex flex-row flex-column-fluid page">
        <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">

            <Header></Header>

            <!--begin::Content-->
            <div class="content d-flex flex-column flex-column-fluid" id="kt_content">

                <!--begin::Entry-->
                <div class="d-flex flex-column-fluid">
                    <!--begin::Container-->
                    <!--begin::Dashboard-->

                    <div class="container">
                        <div class="card card-custom mt-5">
                            <!--begin::Header-->
                            <div class="card-header flex-wrap border-0 pt-6 pb-0">
                                <div class="card-title">
                                    <h3 class="card-label">View Enrolled Bundle Course's
                                        <span class="d-block text-muted pt-2 font-size-sm">View Enrolled Bundle Course's</span></h3>
                                </div>
                                <div class="card-toolbar">
                                    
                                    <router-link to="/addassigngroup">
                                    <button style="float:right;" type="button" class="btn btn-primary font-weight-bolder ml-5">
                                               Assign Bundle Course</button>
                                    </router-link>
                                </div>
                            </div>
                            <!--end::Header-->
                            <div class="card-body">
                                <!--begin: Datatable-->
                                <div class="modal fade" id="staticBackdrop11" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="exampleModalLabel">Update Expiry Date</h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <i aria-hidden="true" class="ki ki-close"></i>
                                                </button>
                                            </div>
                                          
                                            <div class="modal-body">
                                                <div class="form-group">
                                                    <label>Expiry Date</label>
                                                    <div class="input-group date">
                                                        <input type="text" name="expiry_date" class="form-control" id="kt_datepicker_1" placeholder="Select date">
                                                        <div class="input-group-append">
                                                            <span class="input-group-text">
                                                                <i class="la la-calendar-check-o"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-light-primary font-weight-bold" data-dismiss="modal">Close</button>
                                                <button type="submit" class="btn btn-primary font-weight-bold">Update</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div id="example_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                                    
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <table id="example" class="table dataTable no-footer" style="width: 100%;" role="grid" aria-describedby="example_info">
                                                <thead>
                                                    <tr role="row">
                                                        <th  class="sorting sorting_asc" rowspan="1" colspan="1" aria-sort="ascending"  style="width: 120px;">Student Name</th>
                                                        <th  class="sorting"  rowspan="1" colspan="1" style="width: 136px;">Bundle Name</th>
                                                        <th  class="sorting"  rowspan="1" colspan="1" style="width: 136px;">Courses</th>
                                                        <th  class="sorting"  rowspan="1" colspan="1" style="width: 289px;">Enrollment Status</th>
                                                        <th  class="sorting"  rowspan="1" colspan="1" style="width: 216px;">Assigned On</th>
                                                        <th  class="sorting"  rowspan="1" colspan="1" style="width: 188px;">Expired On</th>
                                                        <th  class="sorting"  rowspan="1" colspan="1" style="width: 126px;">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <template v-for="ndata in newAry" >
                                                        <tr class="odd" :key="ndata.id">
                                                            <td class="sorting_1">{{ndata.student_name}}</td>
                                                            <td>{{ndata.group_name}}</td>
                                                            <td>{{ndata.course_name}}</td>
                                                            <td>
                                                                <p v-if="ndata.status==10" class="label label-danger label-pill label-inline mr-2" style="width:auto !important;">
                                                                     Expire
                                                                </p>
                                                                <p v-if="ndata.status==5" class="label label-danger yellow-bg label-pill label-inline mr-2" style="width:auto !important;">
                                                                     Going to expire
                                                                </p>
                                                                <p v-if="ndata.status==1" class="label label-danger green-bg label-pill label-inline mr-2" style="width:auto !important;">
                                                                     Active
                                                                </p>
                                                            </td>
                                                            <td>{{ndata.start_date}}</td>
                                                            <td>{{ndata.exdate}}</td>
                                                            <td>

                                                                <router-link :to="'/editassigngroup/'+ndata.id" class="edit-btn-clr label tbl-action label-inline label-light-danger font-weight-bold"  >
                                                                    <span>Edit</span>
                                                                </router-link>
                                                                <button class="label tbl-action label-inline label-light-danger font-weight-bold" @click="unroll(ndata.id)">
                                                                    <span>UNENROLL</span>
                                                                </button>
                                                        
                                                                
                                                            </td>
                                                        </tr>
                                                    </template>


                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    

                                </div>
                                <!--end: Datatable-->
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>

</div>
</template>

<script>
import axios from 'axios'
import MobileHeader from '../../components/MobileHeader'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Pagination from 'vue-pagination-2';


export default {
    name: 'Student',
    components: {
        Header,
        Footer,
        MobileHeader,
        Pagination,
       

    },
    data() {
        return {
            uid: localStorage.getItem("uid"),
            role: localStorage.getItem("role"),
            pop_val: false,
            edit_pop_val: false,
            course_name: null,
            edit_course_name: null,
            edit_cid: null,
            course_data: [],
            page: 1,
            totalCount: 0,
            newAry: [],
            perPage: 5,
        }
    },
    mounted() {
        if (this.uid == null || this.uid == "") {
            this.$router.push("/");
        }
        this.allCourse();
    },
    watch: {
        page: function (vl) {
            this.changePage();
        }
    },
    methods: {
        changePage() {
            this.course_data = [];
            var preCount = (this.perPage * this.page);

            var temp = this.perPage;
            var newPP = (preCount) - temp;
            //console.log(newPP);
            for (var i = 0; i < temp; i++) {
                if (this.newAry[newPP]) {
                    this.course_data[i] = this.newAry[newPP];
                    newPP++;
                }

            }
        },
        save_course() {
            var ev = this;

            if (this.course_name == null || this.course_name == "") {
                ev.$toasted.global.error({
                    message: "please enter course name"
                });
            } else {
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'lms_api.php',
                    data: {
                        type: 'course_save',
                        course_name: this.course_name,
                        uid: this.uid,
                        role: this.role,
                    }
                }).then(function (response) {
                    //console.log(response.data);
                    var data = response.data;
                    if (data.status == "success") {
                        ev.$toasted.global.success({
                            message: data.msg
                        });
                        ev.course_name = null;
                        ev.pop_val = false;
                        ev.allCourse();
                    } else {
                        ev.$toasted.global.error({
                            message: data.msg
                        });
                    }

                })
            }
        },
        allCourse() {
            var ev = this;
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'lms_api.php',
                data: {
                    type: 'get_group_assign',
                    uid: this.uid,
                    role: this.role,
                }
            }).then(function (response) {
                //console.log(response.data)
                var data = response.data;
                ev.course_data = data.data;
                ev.newAry = data.data;
                ev.totalCount = data.count;
                ev.changePage();

            })
        },
        edit_course() {
            var ev = this;
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'lms_api.php',
                data: {
                    type: 'edit_course',
                    course_name: this.edit_course_name,
                    cid: this.edit_cid,
                }
            }).then(function (response) {
                //console.log(response.data);
                ev.edit_course_name = null;
                ev.edit_cid = null;

            })
        },
        unroll(ids){
             var ev = this;
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'lms_api.php',
                data: {
                    type: 'unroll_group',
                    cid: ids,
                }
            }).then(function (response) {
                var data=response.data;
                 if (data.status == "success") {
                        ev.$toasted.global.success({
                            message: data.msg
                        });
                        ev.allCourse();
                    } else {
                        ev.$toasted.global.error({
                            message: data.msg
                        });
                    }
            })

        }
    },
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {

    .main-popup-overlay {
        padding-top: 30% !important;
        padding-left: 5% !important;
        padding-right: 5% !important;
    }
}

.btn-popup-cancel {
    float: right;
    width: 120px;
}

.main-popup {
    position: fixed;
    width: 100%;
    padding: 20%;
}

.popup-header {
    text-align: center;
}

.btn-div-popup {
    padding-top: 5%;

}

.btn-popup-save {
    float: left;
    width: 120px;

}

.content-start-popup {

    background: #ffffff;
    padding-left: 5%;
    padding-right: 5%;
    padding-top: 10%;
    padding-bottom: 10%;
    border-radius: 15px;
}

.main-popup-overlay {
    position: fixed;
    width: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: #0404046e;
    padding-top: 20%;
    padding-right: 30%;
    padding-left: 30%;
    z-index: 999999999;
}

.btn-top-table {
    display: inline-block;
    padding: 10px;
    width: 50%;
}

.table {
    width: 100%;

}

.table-dt {
    overflow: scroll;
}

.tbl-action {
    margin: 2px;
    border: unset;
}
</style>
